export default __webpack_public_path__ + "static/media/techrate.f6d91757.png";